import { useMemo } from 'react';
import { Client } from './useClients';
import { useResources } from './useResources';

export const useCrisisResourceOptions = (clientId: number, client?: Client) => {
  const { data: clientResources } = useResources(false, undefined, clientId, true);
  const { data: globalResources } = useResources(false, undefined, undefined, client?.use_global_resources ?? false);

  return useMemo(() => {
    const byId = new Map<number, (typeof clientResources)[number]>();
    for (const resource of clientResources ?? []) {
      if (resource.id != null) {
        byId.set(resource.id, resource);
      }
    }
    if (client?.use_global_resources && client.enabled_resource_ids?.length) {
      for (const resource of globalResources ?? []) {
        if (resource.id != null && client.enabled_resource_ids.includes(resource.id)) {
          byId.set(resource.id, resource);
        }
      }
    }
    return [...byId.values()].sort((a, b) => a.name.localeCompare(b.name));
  }, [clientResources, globalResources, client?.use_global_resources, client?.enabled_resource_ids]);
};
